import { useState, useContext, useEffect } from "react";
import { useFirestoreOrderBy } from "../../firebase/useFirestore";
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { db } from "../../firebase/config";
import uuid from "react-uuid";
import { timestamp } from "../../firebase/config";
import { client } from "../../hooks/Client";
import DragIndicatorOutlinedIcon from "@mui/icons-material/DragIndicatorOutlined";
import { SavedIcon } from "../../StateManagment/SavedIcon";
import PairActivities from "./PairActivities";
import Table from "../common/table/Table.jsx";
import TableCell from "../common/table/TableCell.jsx";
import softDeleteDoc from "../../helpers/softDeleteDoc.js";
import { Auth } from "../../StateManagment/Auth";

const StorytellingAnecdotesTab = () => {
  const [, setSaved] = useContext(SavedIcon);
  const [auth] = useContext(Auth);
  const [dragArrayAnecdotes, setDragArrayAnecdotes] = useState([]);

  const anecdotes = useFirestoreOrderBy("Anecdotes", "Position", "asc");
  const activities = useFirestoreOrderBy("Activities", "Position", "asc");

  useEffect(() => {
    setDragArrayAnecdotes(anecdotes || []);
  }, [anecdotes]);

  const handleDragEndAnecdotes = (result) => {
    if (!result.destination) return;

    const items = Array.from(dragArrayAnecdotes);
    const [movedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, movedItem);

    setDragArrayAnecdotes(items);

    items.forEach((item, idx) => {
      db.collection("Anecdotes").doc(item.docid).update({ Position: idx + 1 });
    });

    setSaved("flex");
  };

  const addAnecdote = () => {
    db.collection("Anecdotes").doc().set({
      Anecdote: "",
      Name: "",
      ID: uuid(),
      Timestamp: timestamp,
      CompagnyID: client,
      Position: (anecdotes?.length || 0) + 1,
      Type: "Anecdote",
    });
  };

  const anecdoteHandler = (e) => {
    const docid = e.target.dataset.docid;
    const anecdote = e.target.value;

    db.collection("Anecdotes").doc(docid).update({ Anecdote: anecdote });
  };

  // Zacht verwijderen (ADR-008), zodat een misklik terug te halen is uit de
  // prullenbak. De hooks filteren gemarkeerde documenten centraal weg.
  const deleteAnecdote = async (e) => {
    const docid = e.currentTarget.dataset.docid;
    if (!docid) return;

    await softDeleteDoc({ collection: "Anecdotes", docid, authId: auth?.ID });
    setSaved("flex");
  };

  return (
    <>
      <Table
        columns={[
          { key: "drag", label: "", searchable: false },
          { key: "anecdote", label: "ANEKDOTE" },
          { key: "activities", label: "ACTIVITEIT(EN)", searchable: false },
          { key: "delete", label: "VERWIJDEREN", searchable: false },
        ]}
        items={dragArrayAnecdotes || []}
        getItemKey={(item) => item.ID}
        renderRow={(item) => (
          <>
            <TableCell>
              <DragIndicatorOutlinedIcon />
            </TableCell>
            <TableCell>
              <textarea
                type="text"
                placeholder="Schrijf hier de anekdote"
                data-docid={item.docid}
                defaultValue={item.Anecdote}
                onChange={anecdoteHandler}
              />
            </TableCell>
            <TableCell>
              <PairActivities type={"Anecdotes"} item={item} activities={activities} setSaved={setSaved} />
            </TableCell>
            <TableCell>
              <DeleteOutlinedIcon className="table-delete-icon" data-docid={item.docid} onClick={deleteAnecdote} />
            </TableCell>
          </>
        )}
        searchAccessor={(item) => item?.Anecdote || ""}
        searchPlaceholder="Zoeken op anekdote"
        emptyMessage="Geen anekdotes gevonden."
        draggable
        droppableId="anecdotes"
        onDragEnd={handleDragEndAnecdotes}
        addRow={{
          toolTipContent: "Qoute toevoegen",
          onClick: addAnecdote,
        }}
      />
    </>
  );
};

export default StorytellingAnecdotesTab;
